// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../core/resource.mjs";
export class Passages extends APIResource {
    /**
     * Search passages across the organization with optional agent and archive
     * filtering. Returns passages with relevance scores.
     *
     * This endpoint supports semantic search through passages:
     *
     * - If neither agent_id nor archive_id is provided, searches ALL passages in the
     *   organization
     * - If agent_id is provided, searches passages across all archives attached to
     *   that agent
     * - If archive_id is provided, searches passages within that specific archive
     * - If both are provided, agent_id takes precedence
     */
    search(body, options) {
        return this._client.post('/v1/passages/search', { body, ...options });
    }
}
//# sourceMappingURL=passages.mjs.map